import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    supportedLngs: ["en", "es", "cs", "ar", "he", "it", "pl", "ru", "uk", "de", "fr"],
    fallbackLng: "en",
    ns: ["translation", "home", "about", "modals"],
    defaultNS: "translation",
    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: "/i18n/{{lng}}/{{ns}}.json",
    },
});
export default i18n;
